import { AvailableSlotsResponseDto, RegistrationApiFp } from "@api/api";
import { getApiErrorMessage } from "@core/utility/get-error-message";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { AxiosError } from "axios";
import { useQuery } from "react-query";

const apiRegistrationFp = RegistrationApiFp(apiConfig);

export function useQyGetAvailableSlots(
  tenant: string,
  date: string,
  service: string,
  provider: string,
  enabled?: boolean,
  onSuccess?:
    | ((data: AvailableSlotsResponseDto) => void | Promise<unknown>)
    | undefined,
  onError?: ((error: AxiosError) => void | Promise<unknown>) | undefined,
) {
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (
    tenant: string,
    date: string,
    service: string,
    provider: string,
  ) => {
    showProgress();
    const operation =
      await apiRegistrationFp.registrationControllerGetAvailableSlots(
        tenant,
        date,
        service,
        provider,
      );
    const response = (await operation()).data;
    return response.data as AvailableSlotsResponseDto;
  };

  return useQuery({
    enabled: enabled !== false && !!tenant && !!date,
    queryKey: [QueryKey.AvailableSlots, tenant, date, service, provider],
    queryFn: () => apiFn(tenant, date, service, provider),
    staleTime: 30000, // 30 seconds - slots can change quickly
    onSuccess: (response) => {
      hideProgress();
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);

      if (onError) {
        onError(err);
      }
    },
    onSettled() {
      hideProgress();
    },
  });
}
